import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { PagosRoutingModule } from './pagos-routing.module';
import { PaginacionModule } from '../../parcial/paginacion/paginacion.module';

import { PipesModule } from '../../pipes/pipes.module';
import { PagosFormularioComponent } from './formulario/formulario.component';
import { ListaComponent } from './lista/lista.component';

import { AuthService } from '../../auth.service';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule } from '../../crud/crud.module';
//fin crud

import { VentaModule } from '../../transaccion/venta/venta.module';

import { NgSelect2Module } from 'ng-select2';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagosRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    PaginacionModule,
    PipesModule,
    MenuModule,
    ParcialModule,
    NgSelect2Module,
    NguiAutoCompleteModule,
    
    VentaModule,
    CrudModule
  ],
  declarations: [
    PagosFormularioComponent,
    ListaComponent
  ],
  providers: [AuthService, CrudService]
})

export class PagosModule { }
